<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("paymentAccounts/getForEdit", this.itemId)
            .then((res) => {
                this.paymentAccount = res;
            }).catch(() => { });
    },
    computed: {
    },
    data() {
        return {
            paymentAccount: {
                   hasReference: false,

            },

        };
    },
    methods: {
        confirm() {
            this.$store
                .dispatch("paymentAccounts/edit", { id: this.itemId, payload: this.paymentAccount })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        allowedDates(val) {
            const today = new Date();
            today.setFullYear(today.getFullYear() - 15);
            const date = new Date(val);
            return date < today;
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>